import React from "react";
import ShutdownBanner from "./ShutdownBanner";

function Banner() {
  return <ShutdownBanner />;
}

export default Banner;
